import React from "react";

const LendingPricingSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6.78" height="10.475" viewBox="0 0 6.78 10.475"><path d="M0,0H2.26L6.78,5.237,2.26,10.475H0L4.52,5.092Z"/></svg>
  );
};

export default LendingPricingSvg;
